import React from 'react';
import moment from 'moment';
import { Link, useHistory } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { IntlShape } from 'react-intl';
import { Button } from '@whitelabel/component-library';
import { dateISOtoDDMMMYYYY } from './date';
import supportedLanguages from './supportedLanguages';

import { parseURL, smoothScrollToAnchor } from './url';
import { captureExceptionWithFullyStory } from './utils';

// TODO: Clean up these date and number functions, react-intl should be handling a lot of it out of the box
export const renderDates = ({ start, end = null }: any, locale = moment.locale()) => {
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
  const startDate = dateISOtoDDMMMYYYY(start, locale);
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
  const endDate = end && dateISOtoDDMMMYYYY(end, locale);
  return endDate ? `${startDate} to ${endDate}` : startDate;
};

export const renderAmountWithSymbol = (amount: any, currency: any, locale = null) =>
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(amount);

export const localizePathname = (pathname: any, locale: any) => {
  const pathnameArray = pathname.split('/');
  if (Object.keys(supportedLanguages).includes(pathnameArray[1])) {
    pathnameArray[1] = locale;
  } else {
    pathnameArray.splice(1, 0, locale);
  }
  return pathnameArray.join('/');
};

export const localizeURL = (url: any, locale: any) => {
  // @ts-expect-error ts-migrate(2345) FIXME: Manually added - Property 'origin' does not exist on type '{ pathname: string...
  const { origin, pathname, search, hash } = parseURL(url);
  const localizedPathname = localizePathname(pathname, locale);
  const localizedURL = `${origin || ''}${localizedPathname}${search}${hash}`;
  return localizedURL;
};

export const localizeLocation = (location: any, locale: any) => {
  const { pathname, state } = location;

  if (state && state.referrer) {
    state.referrer.pathname = localizePathname(state.referrer.pathname, locale);
  }

  return {
    ...location,
    pathname: localizePathname(pathname, locale),
    state,
  };
};

function formatAttributes(attribs: any) {
  let result = '';
  if (attribs) {
    result = Object.entries(attribs)
      .map(([name, value]) => `${name}="${value}"`)
      .join(' ');
  }
  return result;
}

function formatChildren(children: any) {
  let result = '';
  children.forEach((element: any) => {
    if (element.type === 'text') {
      result += element.data;
    } else if (element.type === 'tag') {
      result += `<${element.name} ${formatAttributes(element.attribs)}>${formatChildren(element.children)}</${
        element.name
      }>`;
    }
  });
  return result;
}

export const transformLink = (intl: any) => (node: any) => {
  const history = useHistory();
  const setHash = (path: any) => {
    history.push({ hash: path });
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
    smoothScrollToAnchor(path)();
  };

  if (node.type === 'tag' && node.name === 'a') {
    if (!node.attribs.href) {
      const error = new Error('HTML a tag is missing a valid href attribute');
      captureExceptionWithFullyStory(error);
      return;
    }

    if (node.attribs.href.startsWith('/')) {
      const path = localizePathname(node.attribs.href, intl.locale);

      return (
        <Link key={path} to={path}>
          {ReactHtmlParser(formatChildren(node.children))}
        </Link>
      );
    }

    if (node.attribs.href.startsWith('?')) {
      const path = node.attribs.href;

      return (
        <Link key={path} to={path}>
          {ReactHtmlParser(formatChildren(node.children))}
        </Link>
      );
    }

    if (node.attribs.href.startsWith('#')) {
      return (
        <Button
          type="button"
          key={node.attribs.href}
          onClick={() => {
            setHash(node.attribs.href);
          }}
        >
          {ReactHtmlParser(formatChildren(node.children))}
        </Button>
      );
    }
  }
  return undefined;
};

// TODO: put params into an option object and refactor usages
export const formatCurrency = (
  formatNumber: IntlShape['formatNumber'],
  value: any,
  currency: any,
  trimCents = false,
) => {
  if (!value) return value;
  const formattedValue = formatNumber(value, { style: 'currency', currency });
  if (trimCents && formattedValue.endsWith('.00')) {
    return formattedValue.substring(0, formattedValue.indexOf('.00'));
  }
  return formattedValue;
};
